export default {
  REDIRECT_LINK_INTERNAL_FETCHED: 'REDIRECT_LINK_INTERNAL_FETCHED',
  REDIRECT_LINK_INTERNAL_LOAD: 'REDIRECT_LINK_INTERNAL_LOAD',
  REDIRECT_LINK_INTERNAL_TEMPLATES_FETCHED: 'REDIRECT_LINK_INTERNAL_TEMPLATES_FETCHED',
  REDIRECT_LINK_INTERNAL_TEMPLATES_LOAD: 'REDIRECT_LINK_INTERNAL_TEMPLATES_LOAD',
  REDIRECT_LINK_INTERNAL_DETAIL: 'REDIRECT_LINK_INTERNAL_DETAIL',
  REDIRECT_LINK_INTERNAL_BUTTON_LOAD: 'REDIRECT_LINK_INTERNAL_BUTTON_LOAD',
};
